import React from "react"
import {SvgIcon, SvgIconProps} from "@mui/material"

const plusIconSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28">
        <path fill="currentColor" d="M13.9 14.1V22h1.2v-7.9H23v-1.2h-7.9V5h-1.2v7.9H6v1.2h7.9Z"></path>
    </svg>
)

const PlusIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {plusIconSvg}
    </SvgIcon>
)

export default PlusIcon